const ua = window.navigator.userAgent.toLowerCase()
const env = () => {
  if (ua.indexOf('ztopenharmony') !== -1) {
    return 'openharmony'
  }
  if (ua.indexOf('ztflutter') !== -1) {
    return 'flutter'
  }
  if (ua.indexOf('dingtalk') !== -1 && self == top) {
    return 'dingtalk'
  }
  if (ua.indexOf('wxwork') !== -1) {
    return 'wxwork'
  }
  if (ua.indexOf('lark/') !== -1) {
    return 'feishu'
  }
  if (ua.indexOf('qyzone') !== -1) {
    return 'yongyou'
  }
  if (ua.indexOf('miniprogram') !== -1) {
    /** 微信小程序 */
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return 'miniprogram'
    }
    return 'miniprogram'
  }
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return 'weixin'
  }
  return 'web'
}

export default env()
